/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaches_Page_LedeInputs */

const en_coaches_page_lede = /** @type {(inputs: Coaches_Page_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trainers, dieticians and physios nearby, with free hours straight from their calendars. Pick a time and it is yours, with no messages and no waiting for a reply.`)
};

const pl_coaches_page_lede = /** @type {(inputs: Coaches_Page_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trenerzy, dietetycy i fizjoterapeuci w okolicy, z wolnymi godzinami prosto z ich kalendarzy. Wybierasz godzinę i termin jest Twój, bez pisania i czekania na odpowiedź.`)
};

/**
* | output |
* | --- |
* | "Trainers, dieticians and physios nearby, with free hours straight from their calendars. Pick a time and it is yours, with no messages and no waiting for a re..." |
*
* @param {Coaches_Page_LedeInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const coaches_page_lede = /** @type {((inputs?: Coaches_Page_LedeInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaches_Page_LedeInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_coaches_page_lede(inputs)
	return en_coaches_page_lede(inputs)
});